import styled from "styled-components";
import { RowData } from "../../../../../types";
import GoogleMapEmbed from "./GoogleMapEmbed";
import { useInView } from "./hooks/useInView";
import { str, strOrFallback } from "./utils/fieldUtils";

const MapContainer = styled.div`
  width: 100%;
  height: 160px;
  flex-shrink: 0;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  background-color: #e5e7eb;
  position: relative;
`;

const MapPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background-color: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 12px;
`;

/**
 * Build a full address string from a RowData row.
 * Used as geocoding fallback when lat/lng are absent or invalid.
 */
const buildAddress = (building: RowData): string => {
  const addressParts = [
    building.address_line_1,
    building.address_line_2,
    building.city,
    building.state,
    building.zip,
  ]
    .map(str)
    .filter(Boolean);

  return addressParts.join(", ");
};

export default function MapThumbnail({ building }: { readonly building: RowData }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "100px",
  });

  return (
    <MapContainer
      ref={ref}
      aria-label={`Map for ${strOrFallback(building.name)}`}
    >
      {inView ? (
        <GoogleMapEmbed
          lat={building.latitude as number}
          lng={building.longitude as number}
          name={building.name as string}
          address={buildAddress(building)}
        />
      ) : (
        <MapPlaceholder>Loading map…</MapPlaceholder>
      )}
    </MapContainer>
  );
}
